/** Who owes the shop money, and recording what they pay back. */
const credit = {
  en: {
    hasAccount: "has the app",
    title: "Credit",
    subtitle: "Customers who bought on credit, and what they still owe.",
    loadFailed: "Could not load who owes what.",
    totalOwed: "Total owed",
    nobodyOwes: "Nobody owes the shop anything right now.",
    lastSale: "last sold on credit {day}",
    recordPayment: "Record payment",
    paymentFrom: "Payment from {name}",
    currentlyOwed: "Currently owes {amount}.",
    amount: "Amount ({currency})",
    note: "Note (optional)",
    paymentRecorded: "Payment from {name} recorded.",
    paymentRecordedDrawerClosed: "Payment from {name} recorded. The cash drawer is closed, so nothing was added to it.",
    paidTo: "Where did the money go?",
    paidTo_drawer: "Into the cash drawer",
    paidTo_drawer_hint: "Cash handed over in the shop. It is added to the drawer if it is open.",
    paidTo_elsewhere: "Somewhere else",
    paidTo_elsewhere_hint: "A transfer, or cash you kept. The drawer is not touched.",
    paymentFailed: "Could not record that payment.",
    details: "Details",
    hideDetails: "Hide details",
    detailsLoadFailed: "Could not load that customer's purchases.",
    purchasesTitle: "Where this comes from",
    purchasesHint:
      "A payment always pays off the oldest sale first, so this is how each one stands.",
    paidAtSale: "{amount} paid at the till",
    remaining: "{amount} still owed",
    paidOff: "Paid off",
    paymentsTitle: "Payments received",
    noPayments: "No payments recorded yet.",
    paymentNote: "{amount} — {note}",
  },

  fr: {
    hasAccount: "a l'application",
    title: "Crédit",
    subtitle: "Les clients qui ont acheté à crédit, et ce qu'ils doivent encore.",
    loadFailed: "Impossible de charger qui doit quoi.",
    totalOwed: "Total dû",
    nobodyOwes: "Personne ne doit rien à la boutique pour l'instant.",
    lastSale: "dernier achat à crédit le {day}",
    recordPayment: "Enregistrer un paiement",
    paymentFrom: "Paiement de {name}",
    currentlyOwed: "Doit actuellement {amount}.",
    amount: "Montant ({currency})",
    note: "Note (facultatif)",
    paymentRecorded: "Paiement de {name} enregistré.",
    paymentRecordedDrawerClosed: "Paiement de {name} enregistré. La caisse est fermée, rien n'y a donc été ajouté.",
    paidTo: "Où est allé l'argent ?",
    paidTo_drawer: "Dans la caisse",
    paidTo_drawer_hint: "Espèces remises en boutique. Ajouté à la caisse si elle est ouverte.",
    paidTo_elsewhere: "Ailleurs",
    paidTo_elsewhere_hint: "Un virement, ou des espèces que vous avez gardées. La caisse n'est pas touchée.",
    paymentFailed: "Impossible d'enregistrer ce paiement.",
    details: "Détails",
    hideDetails: "Masquer les détails",
    detailsLoadFailed: "Impossible de charger les achats de ce client.",
    purchasesTitle: "D'où vient ce montant",
    purchasesHint:
      "Un paiement solde toujours la vente la plus ancienne en premier, voici donc où en est chacune.",
    paidAtSale: "{amount} payé à la caisse",
    remaining: "{amount} encore dû",
    paidOff: "Soldée",
    paymentsTitle: "Paiements reçus",
    noPayments: "Aucun paiement enregistré pour l'instant.",
    paymentNote: "{amount} — {note}",
  },

  ar: {
    hasAccount: "لديه التطبيق",
    title: "الديون",
    subtitle: "الزبائن الذين اشتروا بالدين، وما تبقى عليهم.",
    loadFailed: "تعذّر تحميل قائمة من يدين بماذا.",
    totalOwed: "إجمالي الديون",
    nobodyOwes: "لا أحد يدين للمتجر بشيء حالياً.",
    lastSale: "آخر شراء بالدين في {day}",
    recordPayment: "تسجيل دفعة",
    paymentFrom: "دفعة من {name}",
    currentlyOwed: "يدين حالياً بـ {amount}.",
    amount: "المبلغ ({currency})",
    note: "ملاحظة (اختياري)",
    paymentRecorded: "تم تسجيل دفعة من {name}.",
    paymentRecordedDrawerClosed: "تم تسجيل دفعة من {name}. الصندوق مغلق، لذلك لم يُضف إليه شيء.",
    paidTo: "أين ذهب المبلغ؟",
    paidTo_drawer: "في الصندوق",
    paidTo_drawer_hint: "نقد سُلّم في المحل. يُضاف إلى الصندوق إذا كان مفتوحاً.",
    paidTo_elsewhere: "في مكان آخر",
    paidTo_elsewhere_hint: "تحويل، أو نقد احتفظتَ به. لا يتأثر الصندوق.",
    paymentFailed: "تعذّر تسجيل هذه الدفعة.",
    details: "التفاصيل",
    hideDetails: "إخفاء التفاصيل",
    detailsLoadFailed: "تعذّر تحميل مشتريات هذا الزبون.",
    purchasesTitle: "من أين يأتي هذا المبلغ",
    purchasesHint:
      "الدفعة تُسدَّد دائماً على أقدم عملية بيع أولاً، وهذا وضع كل واحدة منها.",
    paidAtSale: "دُفع {amount} عند البيع",
    remaining: "متبقٍ {amount}",
    paidOff: "مسدَّدة",
    paymentsTitle: "الدفعات المستلمة",
    noPayments: "لا توجد دفعات مسجّلة بعد.",
    paymentNote: "{amount} — {note}",
  },
};

export default credit;
